/**
 * Finds and returns first instance of predicate in a recursive tree dictionary.
 *
 * @example
 *   const input = [
 *     {
 *       label: 'a',
 *       items: [
 *         {
 *           label: 'b',
 *           items: [{ label: 'c' }],
 *         },
 *       ],
 *     },
 *     {
 *       label: 'x',
 *       items: [{ label: 'y' }],
 *     },
 *   ];
 *
 *   treeFind(input, (item) => item.label === 'c', 'items');
 *
 *   const output = { label: 'c' };
 *
 * @param items The tree of items.
 * @param predicateFn The predicate for finding the item.
 * @param childrenKey The key used to store the nested items.
 */
export function treeFind(items, predicateFn, childrenKey) {
    const item = items.find(predicateFn);
    if (item) {
        return item;
    }
    const itemsWithChildren = items.filter((item) => childrenKey in item);
    for (let index = 0; index < itemsWithChildren.length; index++) {
        const item = treeFind(itemsWithChildren[index][childrenKey], predicateFn, childrenKey);
        if (item) {
            return item;
        }
    }
}
